export default __webpack_public_path__ + "static/media/lbasic2.03c69df2.svg";